var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7645df6185519c8e3c733eb27cf999be.svg#j';
                    var viewUrl = 'sprites.7645df6185519c8e3c733eb27cf999be.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 108 128',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };